import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { MeetingConnectionsFormVM } from '../meeting-connections-form.viewmodel';
import { SendConnectionsEmailFormPresentation } from './send-connections-email-form-presentation';
import { SendConnectionsEmailFormViewmodel } from './send-connections-email-form.viewmodel';

interface IProps {
    meetingConnectionsFormVM: MeetingConnectionsFormVM;
}

export const SendConnectionsEmailForm = withViewModel(SendConnectionsEmailFormPresentation, async ({
    meetingConnectionsFormVM,
}: IProps) => {
    const vm = new SendConnectionsEmailFormViewmodel(
        meetingConnectionsFormVM,
    );
    await vm.initialize();
    return vm;
});
